import {
    EndGameRankedUserState,
    RankedMMRState,
    RankedPlacementState,
    RankedUserStateType,
} from '@colonist/leaderboard-types'
import {SectionBgView} from '../../ui_canvas_engine/SectionBgView'
import {UIGameManager} from '../UIGameManager'
import {UIGameEndFooterController} from './UIGameEndFooterController'
import {GameEndMMRChangeView} from './GameEndMMRChangeView'
import {GameEndPlacementChangeView} from './GameEndPlacementChangeView'
import {BaseEndGameRankedChangeView} from './BaseEndGameRankedChangeView'
import {HideableEndGameSection} from './UIGameEndController'

export class UIGameRankedEndController {
    readonly uiGameManager: UIGameManager
    readonly contentContainer: SectionBgView
    readonly sectionSize: number

    private readonly viewsToHide: HideableEndGameSection[]
    private readonly footerController: UIGameEndFooterController

    private readonly gameEndRankedChangeView: BaseEndGameRankedChangeView
    private readonly myRankedState: EndGameRankedUserState

    constructor(uiGameManager: UIGameManager, contentContainer: SectionBgView, sectionSize: number, viewsToHide: HideableEndGameSection[], footerController: UIGameEndFooterController, myRankedState: EndGameRankedUserState) {
        this.uiGameManager = uiGameManager
        this.contentContainer = contentContainer
        this.sectionSize = sectionSize
        this.viewsToHide = viewsToHide
        this.footerController = footerController
        this.myRankedState = myRankedState

        viewsToHide.forEach((view) => view.hide())

        const continueAction = () => this.clickedContinueOnRankedUpdateScreen()
        this.footerController.showContinueButton(continueAction)
        this.gameEndRankedChangeView = this.getGameEndRankedChangeView()
    }

    private getGameEndRankedChangeView(): BaseEndGameRankedChangeView {
        switch(this.myRankedState.rankedState.type) {
            case RankedUserStateType.Ranked: return new GameEndMMRChangeView(this, this.myRankedState.rankedState as RankedMMRState, this.footerController)
            case RankedUserStateType.RankedLocked:
            case RankedUserStateType.Placement: return new GameEndPlacementChangeView(this, this.myRankedState.rankedState as RankedPlacementState, this.footerController)
        }
    }

    private clickedContinueOnRankedUpdateScreen() {
        this.gameEndRankedChangeView.hide()

        this.viewsToHide.forEach((view) => view.show())

        // this.contentContainer.addChild(this.statsController.container)
        this.footerController.showGeneralButtons()
    }
}
